<template>
  <div class="checkbox">
    <label :for="`checkbox${index}`" class="checkbox_label">
      <a
        :href="builtQueryString"
        :title="tag.tagAllSlug"
        class="active"
      >
        <span>{{ tag.tagName }}</span>
        <i class="lni lni-close"></i>
      </a>
    </label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TagListingFiltersModel from './tag/filters/Models/TagListingFiltersModel'

export default {
  name: 'AdvListingUsedTag',
  props: {
    group: {
      tagDisplayType: '',
      tagGroupId: '',
      tagGroupName: null,
      tagGroupStep: 0,
      tagGroupDisplayPosition: 0,
      tags: []
    },
    tag: {
      tagDisplayValue: '',
      tagId: '',
      tagName: ''
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'getActiveTagFilters',
      'getTagRecordsUsed',
      'getFilterQueryStringVar',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getCurrentPageNumber',
      'getActiveVariationFiltersString',
      'getActiveAttributeFiltersString',
      'config'
    ]),
    builtQueryString () {
      return this.filteringManage(this.group, this.tag)
    },
    activeFiltersString () {
      const variationFiltersString = this.getActiveVariationFiltersString
      const attributeFiltersString = this.getActiveAttributeFiltersString
      if (variationFiltersString !== '' && attributeFiltersString !== '') {
        return variationFiltersString + '&' + attributeFiltersString
      }
      if (variationFiltersString !== '') {
        return variationFiltersString
      }
      if (attributeFiltersString !== '') {
        return attributeFiltersString
      }
      return ''
    }
  },
  methods: {
    filteringManage (group, entry) {
      const isFilterUsed = true
      const duplicateAttributeGroupNamesPerGroup = {}
      return new TagListingFiltersModel(
        this.getUriWithoutOffset,
        this.getFilterQueryStringVar,
        this.getActiveTagFilters,
        this.getIsTopLevelCategory,
        this.getCurrentPageNumber,
        this.config.url.lang,
        this.activeFiltersString,
        duplicateAttributeGroupNamesPerGroup
      ).createLinkQueryStringFinal(group, entry, isFilterUsed)
    }
  }
}
</script>

<style lang="scss" scoped>
.prod_list_header_filters {
  display: grid;
  grid-template-columns: auto auto auto;
  align-items: center;
  margin-bottom: 45px;
}
.checkbox {
  position: relative;
  width: 100%;
  display: grid;
  margin: 0;
  border: 1px solid black;
  border-radius: 8px;
  font-size: 14px;
  padding: 0 10px;
  line-height: 1.2;
  font-weight: 500;
  height: 40px;
  .checkbox_label {
    display: flex;
    padding: 0 10px;
    cursor: pointer;
    color: black;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.3;
    height: 100%;
    align-items: center;
    align-content: center;
    margin: 0;
    @media screen and (max-width: 992px) {
      font-size: 13px;
    }
    &:before{
      display: none
    }
    a {
      display: grid;
      gap: 5px;
      grid-template-columns: 1fr auto;
      align-items: center;
      @media screen and (max-width: 992px) {
        color: #000000;
        font-weight: normal;
      }
      i {
        color: black;
      }
    }
  }
  .checkbox_input:checked+.checkbox_label::before {
    display: none
  }
}
.native_slider-lg {
  border-right: 1px solid #707070;
}
</style>
